import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center pb-3 mb-10 border-b-2 border-brand-400" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 place-items-start" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center w-full mt-10 text-4xl text-gray-300"
}

import JobRoleTimeCard from './components/JobRoleTimeCard.vue'

	import {
		getJobRolesByContactID,
	} from './queries'

	import {
		FindParameters
	} from '@/types'

	import EventBus from '@/events'

	// store
	import { 
		store as _userStore
	} from '@/store/user'
	import { 
		localesStore
	} from '@/store/locales'

	import {
		ref,
		computed,
		onMounted,
		onBeforeUnmount
	} from 'vue'

	import {
		useI18n
	} from 'vue-i18n'


	
	const __default__ = { name: 'TodaysJobs' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const userStore = _userStore()
	const _localesStore = localesStore()

	const {t} = useI18n()

	const loading = ref(false)

	const roles = ref<Object[]>([])
	const noJobs = ref(false)

	const breadcrumb = computed(() => {
		return [
			{label: t('nav.todaysJobs'), to: {name: 'todaysJobs'}}
		]
	})

	onMounted(async () => {
		getData()

		EventBus.on('change-language', async () => {
			await getData()
		})
	})

	onBeforeUnmount(() => {
		EventBus.off('change-language', null)
	})

	async function getData() {
		try {
			loading.value = true
			const today = new Date()
			const contactId = userStore.user.contactId
			const sessionId = userStore.user.sessionId			
			const setLanguageScriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				sessionId,
				contactId
			})
			let params: FindParameters = {
				query: [
					{
						"JOBS_ROLES::_kf_contacts_id": contactId,
						"JOBS_ROLES::job_date_start": `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`
					}
				],
				"script.prerequest": "Set Language",
				"script.prerequest.param": setLanguageScriptParams
			}

			let res = await getJobRolesByContactID(params)

			const foundRoles = res?.response?.data?.map((record: any) => {
				const fieldData = record.fieldData
				return {
					nameBridgeGroomDisplay: fieldData['jobs_roles__JOBS__jobID::name_bride_groom_display'],
					dateStart: fieldData['job_date_start'],
					dateDayCode: fieldData['jobs_roles__JOBS__jobID::date_start_name_code'],
					timeStart: fieldData['jobs_roles__JOBS__jobID::time_start'],
					timeEnd: fieldData['jobs_roles__JOBS__jobID::time_end'],
					timeArrival: fieldData['jobs_roles__JOBS__jobID::time_arrival'],
					typeDisplay: fieldData['jobs_roles__JOBS__jobID::type_display'],
					categoryDisplay: fieldData['jobs_roles__JOBS__jobID::category_display'],
					companyDisplay: fieldData['jobs_roles__jobs__CONTACTS__locationID::company_display'],
					contactID: fieldData['_kf_contacts_id'],
					roleID: fieldData['_kp_jobs_roles_id'],
					recordID: fieldData['jobs_roles__JOBS__jobID::recordId'],
					departureTime: fieldData['departureTimeActual'],
					arrivalTime: fieldData['arrivalTimeActual']
				}
			})
			roles.value = [...foundRoles]
			if (roles.value.length === 0) {
				noJobs.value = true
			} else {
				noJobs.value = false
			}
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	}


return (_ctx: any,_cache: any) => {
  const _component_tw_breadcrumb = _resolveComponent("tw-breadcrumb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tw_breadcrumb, { crumbs: breadcrumb.value }, null, 8, ["crumbs"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
        return (_openBlock(), _createBlock(JobRoleTimeCard, {
          role: role,
          key: role.roleID
        }, null, 8, ["role"]))
      }), 128))
    ]),
    (noJobs.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_unref(t)('placeholders.noJobsToday')) + "...", 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})